module.exports = __webpack_public_path__ + "img/share_kakao.080f8ded.png";